import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import {
  Grid,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import * as utils from 'containers/RecapManagerPage/utils';

import messages from 'containers/CourtManagerLegalProceedings/messages';
import { get, isEmpty, uniqueId } from 'lodash';

import {
  ASSIGNMENT_FIELDS,
  ITEM_KEYS,
  SAGIS_KEYS,
} from 'containers/RecapManagerPage/constants';
import { CodesConfig, SagisConfig } from 'containers/AppContainer/typings';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { Autocomplete } from '@material-ui/lab';
import { filterStackHolder } from 'services/utils';
export interface assignBlocProps {
  intl: IntlShape;
  zonesCodes: CodesConfig[];
  subServices: SagisConfig[];
  services: SagisConfig[];
  stackholders: SagisConfig[];
  stackholderTypes: SagisConfig[];
  requestCorporealLawyers?: Function;
  corporealLawyers: KeycloakUser[];
  handleChangeAssignedLawyer: Function;
  handleChangeMultipleAssignedLawyer?: Function;
  assignedLawyer?: any;
  assignedLawyers?: any;
  disableInput?: boolean;
}
const AssignBlocForm: React.FC<assignBlocProps> = (props): JSX.Element => {
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [assignTo, setAssignTo] = React.useState({
    subService: '',
    lawyer: props.assignedLawyer ? props.assignedLawyer : '',
  });
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);

  const handleChange = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value, name } = event.target;
    setAssignTo(ele => ({ ...ele, [name as string]: value }));
    props.handleChangeAssignedLawyer(event);
  };
  React.useEffect(() => {
    props.requestCorporealLawyers && props.requestCorporealLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    const _stackholders = utils.getListBySagisKey(
      props.stackholderTypes,
      props.stackholders,
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = utils.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    if (!isEmpty(get(props, 'assignedLawyers', []))) {
      setAssignedLawyers(
        props.assignedLawyers.map((el: any) =>
          stakeholders.find((item: any) => String(item.ItemKey) === String(el)),
        ),
      );
    }
  }, [props.stackholderTypes, props.stackholders, props.corporealLawyers]);
  const [assignedLawyers, setAssignedLawyers] = React.useState<any>([]);

  const handleChangeMultipleAssignment = (
    event: React.ChangeEvent<{}>,
    value: any,
  ) => {
    setAssignedLawyers(value);
    props.handleChangeMultipleAssignedLawyer &&
      props.handleChangeMultipleAssignedLawyer({
        ...event,
        target: { ...event.target, value: value.map((el: any) => el?.ItemKey) },
      });
  };

  return (
    <>
      <Grid container direction="row" spacing={2}>
        {!featureService.hasFeature(FEATURES.ASSIGNMENT_MULTIPLE_LAWYERS) ? (
          <Grid item xs={4}>
            <FormControl className="select">
              <InputLabel
                ref={inputLabel}
                id="demo-simple-select-outlined-label"
              >
                {translate({ ...messages.assignLawyer }, props)}
              </InputLabel>
              <Select
                name={ASSIGNMENT_FIELDS.LAWYER}
                value={assignTo.lawyer}
                onChange={handleChange}
                labelWidth={60}
              >
                {!isEmpty(stakeholders) &&
                  filterStackHolder(stakeholders).map((val: any) => (
                    <MenuItem
                      key={uniqueId('stackholder_')}
                      value={val.ItemKey}
                    >
                      {val.ItemDescription}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <Grid item xs={8}>
            <FormControl className="select">
              <Autocomplete
                className="lawyer-item"
                multiple
                disabled={props.disableInput ? props.disableInput : false}
                id="assignedLawyers"
                options={filterStackHolder(stakeholders)}
                getOptionLabel={(option: any) =>
                  `${option?.ItemDescription ? option?.ItemDescription : ''}`
                }
                value={assignedLawyers}
                onChange={handleChangeMultipleAssignment}
                renderInput={params => (
                  <TextField
                    {...params}
                    variant="standard"
                    disabled={props.disableInput ? props.disableInput : false}
                  />
                )}
              />
            </FormControl>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default injectIntl(AssignBlocForm);
